<template>
  <div ref="container" class="homeContent" @scroll="handelScroll">
    <summary-com ref="dom" @scrollTo="callbackScrollTo"/>
  </div>
</template>

<script>
import summary from "@/components/summary/index";

export default {
  name: "dashboardIndex",
  components: {
    "summary-com": summary
  },
  methods: {
    handelScroll(e) {
      this.$refs.dom.sticky = e.target.scrollTop > 64
    },
    callbackScrollTo: function (top) {
      this.$refs.container.scrollTo({top: top - 150})
    }
  }
};
</script>
<style scoped>
.homeContent {
  background: #f3f3f3;
  padding: 20px;
  box-sizing: border-box;
  overflow-x: hidden;
  height: 100%;
  overflow-y: auto;
}
</style>
